/* global userUpdateProfileUrl */

function updateUserProfileData()
{
    $('#userInlineResLoader').show();
    $('#reservationUserWrap').find('input').blur();

    var profileUpdatePostData = {};
    var profileUpdateFormName = 'user_update_profile';
    var newsletterCheckbox = $('#R_user_update_profile_newsletter');

    $('[name*="['+profileUpdateFormName+']"]').each(function(){
        var name = '[' + $(this).attr('name').replace(/^[a-zA-Z]+\[/, '');
        name = name.replace('['+profileUpdateFormName+'][', '').replace(/]/gi, '');

        if (name.indexOf('phone') === 0) {
            if (profileUpdatePostData.phone === undefined) {
                profileUpdatePostData['phone'] = {};
            }

            profileUpdatePostData['phone'][name.replace('phone[', '')] = $(this).val();
        } else {
            profileUpdatePostData[name] = $(this).val();
        }
    });

    if (newsletterCheckbox.is(":checked")) {
        profileUpdatePostData.newsletter = 1;
    } else {
        profileUpdatePostData.newsletter = 0;
    }

    $.post(userUpdateProfileUrl, {'sfApplySettings' : profileUpdatePostData}, function(response){
        if (response.status == 'success') {
            changeStep(3);
        } else {
            $('#reservationUpdateProfile').html(response.data);
            $('#userInlineResLoader').hide();
        }
    });
}

$(function(){
    $(document).on('click', '#updateProfileData', function(){ updateUserProfileData(); });
});
